import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'

export const OpportunityActivityInfoComponent = ({
    handleTaskActivityInnerFormChange, handleCallActivityInnerFormChange, 
    selectedOpportunityTaskActivity, selectedOpportunityCallLog, 
    sourceType, contactNameLists, leads, taskStatus
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Subject"
                            name="Subject"
                            onValueChange={(event: any) => {
                                handleTaskActivityInnerFormChange(
                                    event.target.value,
                                    'Subject'
                                )
                            }}
                            type="text"
                            value={selectedOpportunityTaskActivity?.Subject}
                        />
                        <InputContainer
                            label="Body"
                            name="Body"
                            onValueChange={(event: any) => {
                                handleTaskActivityInnerFormChange(
                                    event.target.value,
                                    'Body'
                                )
                            }}
                            type="text"
                            value={selectedOpportunityTaskActivity?.Body}
                        />
                        <InputContainer
                            label="Source Type"
                            labelField="RelatedToType"
                            list={sourceType}
                            onValueChange={(event: any, newValue: any) => {
                                handleTaskActivityInnerFormChange(
                                    event.target.value,
                                    'SourceTypeId'
                                );
                            }}
                            optionName='Choose Source Type'
                            type="select"
                            value={selectedOpportunityTaskActivity?.SourceTypeId}
                            valueField="RelatedToTypeId"
                        />
                        {selectedOpportunityTaskActivity?.SourceTypeId === 9 &&
                            <InputContainer
                                label="Source"
                                labelField="FirstName"
                                list={leads}
                                onValueChange={(event: any, newValue: any) => {
                                    handleTaskActivityInnerFormChange(
                                        event.target.value,
                                        'SourceId'
                                    );
                                }}
                                optionName='Choose Leads'
                                type="select"
                                value={selectedOpportunityTaskActivity?.SourceId}
                                valueField="Id"
                            />
                        }
                        {selectedOpportunityTaskActivity?.SourceTypeId === 11 &&
                            <InputContainer
                                label="Source"
                                labelField="displayText"
                                list={contactNameLists}
                                onValueChange={(event: any, newValue: any) => {
                                    handleTaskActivityInnerFormChange(
                                        event.target.value,
                                        'SourceId'
                                    );
                                }}
                                optionName='Choose Contacts'
                                type="select"
                                value={selectedOpportunityTaskActivity?.SourceId}
                                valueField="Id"
                            />
                        }
                        <InputContainer
                            label="Status"
                            labelField="Text"
                            list={taskStatus}
                            onValueChange={(event: any, newValue: any) => {
                                handleTaskActivityInnerFormChange(
                                    event.target.value,
                                    'Status'
                                );
                            }}
                            optionName='Choose Status'
                            type="select"
                            value={selectedOpportunityTaskActivity?.Status}
                            valueField="Value"
                        />
                        <InputContainer
                            label="StartDate"
                            name="StartDate"
                            onValueChange={(event: any) => {
                                handleTaskActivityInnerFormChange(
                                    event.target.value,
                                    'StartDate'
                                )
                            }}
                            type="date"
                            value={selectedOpportunityTaskActivity?.StartDate}
                        />
                        <InputContainer
                            label="EndDate"
                            name="EndDate"
                            onValueChange={(event: any) => {
                                handleTaskActivityInnerFormChange(
                                    event.target.value,
                                    'EndDate',
                                )
                            }}
                            type="date"
                            value={selectedOpportunityTaskActivity?.EndDate}
                        />
                    </div>
                }
                expandedPanel="Task Activity"
                headerTitle="Task Activity"
            />
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Subject"
                            name="Subject"
                            onValueChange={(event: any) => {
                                handleCallActivityInnerFormChange(
                                    event.target.value,
                                    'Subject'
                                )
                            }}
                            type="text"
                            value={selectedOpportunityCallLog?.Subject}
                        />
                        <InputContainer
                            label="Body"
                            name="Body"
                            onValueChange={(event: any) => {
                                handleCallActivityInnerFormChange(
                                    event.target.value,
                                    'Body'
                                )
                            }}
                            type="text"
                            value={selectedOpportunityCallLog?.Body}
                        />
                        <InputContainer
                            label="Source Type"
                            labelField="RelatedToType"
                            list={sourceType}
                            onValueChange={(event: any, newValue: any) => {
                                handleCallActivityInnerFormChange(
                                    event.target.value,
                                    'SourceTypeId'
                                );
                            }}
                            optionName='Choose Source Type'
                            type="select"
                            value={selectedOpportunityCallLog?.SourceTypeId}
                            valueField="RelatedToTypeId"
                        />
                        {selectedOpportunityCallLog?.SourceTypeId === 11 &&
                            <InputContainer
                                label="Source"
                                labelField="displayText"
                                list={contactNameLists}
                                onValueChange={(event: any, newValue: any) => {
                                    handleCallActivityInnerFormChange(
                                        event.target.value,
                                        'SourceId'
                                    );
                                }}
                                optionName='Choose Contacts'
                                type="select"
                                value={selectedOpportunityCallLog?.SourceId}
                                valueField="Id"
                            />
                        }
                        {selectedOpportunityCallLog?.SourceTypeId === 9 &&
                            <InputContainer
                                label="Source"
                                labelField="FirstName"
                                list={leads}
                                onValueChange={(event: any, newValue: any) => {
                                    handleCallActivityInnerFormChange(
                                        event.target.value,
                                        'SourceId'
                                    );
                                }}
                                optionName='Choose Leads'
                                type="select"
                                value={selectedOpportunityCallLog?.SourceId}
                                valueField="Id"
                            />
                        }
                    </div>
                }
                expandedPanel="Call Log"
                headerTitle="Call Log"
            />
        </>
    )
}
export default OpportunityActivityInfoComponent;
